module.exports = __webpack_public_path__ + "img/mii-gunner-min.a01b571b.png";